var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKids(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7sor0hzi8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.996 1.002C21.25 1.002 2 20.252 2 43.998c0 23.747 19.25 42.997 42.996 42.997 23.747 0 42.997-19.25 42.997-42.997 0-23.746-19.25-42.996-42.997-42.996zm0 65.107c-12.21 0-22.109-9.898-22.109-22.11 0-12.21 9.897-22.11 22.11-22.11 12.212 0 22.108 9.898 22.108 22.11 0 12.21-9.898 22.11-22.109 22.11z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 11.135c-18.15 0-32.863 14.713-32.863 32.863 0 18.152 14.713 32.864 32.863 32.864S77.86 62.15 77.86 43.998c0-18.15-14.714-32.863-32.864-32.863zm0 54.974c-12.21 0-22.109-9.898-22.109-22.11 0-12.21 9.897-22.11 22.11-22.11 12.212 0 22.108 9.899 22.108 22.11 0 12.21-9.898 22.11-22.109 22.11z",
    fill: "#CDD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.154 14.223 3.35 10.312a22.007 22.007 0 0 1 10.49-2.648c3.796 0 7.368.96 10.49 2.648 1.117-3.438 2.231-6.874 3.351-10.312-4.214-1.963-8.891-3.09-13.843-3.09s-9.626 1.127-13.838 3.09z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.987 4.497c-1.04 3.245-2.096 6.486-3.153 9.73-4.212-1.972-8.888-3.099-13.833-3.099a32.542 32.542 0 0 0-13.848 3.1c-1.04-3.245-2.096-6.486-3.153-9.71a42.662 42.662 0 0 1 17.002-3.512c6.037 0 11.79 1.234 16.985 3.491z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.839 73.77c-1.117-3.437-2.236-6.873-3.352-10.311a22.008 22.008 0 0 1-10.49 2.648c-3.796 0-7.368-.96-10.489-2.648-1.116 3.438-2.232 6.874-3.352 10.312 4.214 1.963 8.892 3.09 13.843 3.09 4.952 0 9.626-1.127 13.84-3.09z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.987 83.503C56.792 85.76 51.041 87 45.004 87a42.695 42.695 0 0 1-17.002-3.514c1.057-3.242 2.114-6.483 3.153-9.71 4.212 1.953 8.888 3.084 13.848 3.084 4.945 0 9.62-1.131 13.833-3.084 1.057 3.245 2.112 6.486 3.151 9.728z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.77 30.156-10.311 3.35a22.04 22.04 0 0 1 2.648 10.492c0 3.796-.962 7.368-2.648 10.489 3.438 1.116 6.874 2.232 10.312 3.35 1.962-4.212 3.088-8.89 3.088-13.841 0-4.95-1.126-9.626-3.088-13.84z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 44.001c0 6.038-1.234 11.789-3.493 16.984-3.243-1.04-6.485-2.096-9.728-3.153 1.953-4.212 3.082-8.886 3.082-13.832 0-4.963-1.129-9.639-3.082-13.847 3.225-1.04 6.468-2.096 9.71-3.153a42.706 42.706 0 0 1 3.512 17.001z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.221 57.839c3.438-1.116 6.874-2.234 10.314-3.35a22.02 22.02 0 0 1-2.648-10.491c0-3.795.96-7.367 2.648-10.49-3.44-1.116-6.876-2.232-10.314-3.35-1.961 4.212-3.088 8.89-3.088 13.841 0 4.95 1.127 9.626 3.088 13.84z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.13 44c0 4.946 1.128 9.62 3.097 13.832-3.242 1.057-6.485 2.114-9.728 3.153C3.24 55.79 2.006 50.04 2.006 44.002a42.691 42.691 0 0 1 3.511-17c3.243 1.057 6.468 2.114 9.71 3.153A32.54 32.54 0 0 0 12.13 44z",
    fill: "#FF7058"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3v5p4e0z8b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.276 69.368a18.615 18.615 0 0 0-6.277-1.087c-2.202 0-4.314.384-6.277 1.087l-10.847 10.15L33.095 88h21.807l6.222-8.484a18.77 18.77 0 0 0-10.848-10.15z",
    fill: "#7CE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 68.281c-2.203 0-4.315.384-6.278 1.087a18.77 18.77 0 0 0-10.847 10.15L33.095 88h3.182v-1.048c.01-8.113 4.85-15.095 11.801-18.221a18.665 18.665 0 0 0-4.079-.45z",
    fill: "#55DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.723 69.367c1.102 2.891 3.307 5.18 6.277 6.77 2.97-1.59 5.174-3.879 6.277-6.77H37.723zM33.095 84.025a42.274 42.274 0 0 1-6.22-4.508 18.56 18.56 0 0 0-1.547 7.437V88h7.767v-3.976zM9.035 43.66a8.693 8.693 0 1 0 0-17.387 8.693 8.693 0 0 0 0 17.387zM78.965 43.66a8.693 8.693 0 1 0 0-17.387 8.693 8.693 0 0 0 0 17.387z",
    fill: "#FFBF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 0 9.035 34.966l15.67 21.424a31.681 31.681 0 0 0 25.572 12.977 34.785 34.785 0 0 0 3.525-.832c14.54-4.238 25.164-17.662 25.164-33.57L44 0z",
    fill: "#FFD4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.626 34.965H9.036c0 15.907 10.623 29.332 25.162 33.57A34.972 34.972 0 0 0 44 69.93c2.112 0 4.207-.188 6.277-.564-16.552-2.761-29.651-17.065-29.651-34.401z",
    fill: "#FFBF9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.701 49.287c3.423 0 6.197-2.18 6.197-4.869 0-2.69-2.774-4.87-6.197-4.87-3.422 0-6.197 2.18-6.197 4.87s2.774 4.87 6.197 4.87zM62.246 49.287c3.423 0 6.197-2.18 6.197-4.869 0-2.69-2.774-4.87-6.197-4.87s-6.197 2.18-6.197 4.87 2.774 4.87 6.197 4.87z",
    fill: "#FF8E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.235 15.78-8.94 4.517-2.76 8.037c4.728 4.139 10.92 6.629 17.43 6.63a34.802 34.802 0 0 0-5.73-19.185z",
    fill: "#E8B5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.334 3.342a46.325 46.325 0 0 1-7.132 3.818 35.024 35.024 0 0 0-4.785-3.074L18.662 10.87l7.27 22.5a2.302 2.302 0 0 0 2.191 1.594l12.643-.006c17.335-.327 31.75-12.207 36.298-28.15.797-2.792-2.3-5.055-4.73-3.466z",
    fill: "#D6948C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.795.478A35.2 35.2 0 0 0 44 0c-9.97 0-18.967 4.174-25.337 10.87-5.966 6.272-9.628 14.756-9.628 24.095h19.09c-1.52-2.292-1.875-5.128-1.16-7.783A29.52 29.52 0 0 1 38.25 10.866 29.591 29.591 0 0 1 50.67 5.718l9.748-1.632A34.694 34.694 0 0 0 49.795.478z",
    fill: "#CE857A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.605 38.154c-.733 0-1.328.595-1.328 1.328v2.382a1.328 1.328 0 0 0 2.656 0v-2.382c0-.733-.594-1.328-1.328-1.328zM56.394 38.154c-.733 0-1.328.595-1.328 1.328v2.382a1.328 1.328 0 0 0 2.656 0v-2.382c0-.733-.594-1.328-1.328-1.328zM48.14 40.792a1.328 1.328 0 0 0-1.873.128A3.007 3.007 0 0 1 44 41.953a3.007 3.007 0 0 1-2.267-1.033 1.328 1.328 0 0 0-2.002 1.745 5.662 5.662 0 0 0 8.538 0 1.328 1.328 0 0 0-.129-1.873z",
    fill: "#313D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.124 79.516a42.463 42.463 0 0 1-6.222 4.509v3.974h7.77v-1.047c0-2.642-.554-5.156-1.548-7.436z",
    fill: "#FFD4BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7sor0hzi8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 1)",
    d: "M0 0h86v86H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3v5p4e0z8b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h88v88H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/kids.0c076bd4bfea487ce3abf176e5efbe5e.svg";
export { ForwardRef as ReactComponent };